import type { QuizTotal } from '@efdigital/ll-addon-data';
import { type TemplateOnlyComponent } from '@ember/component/template-only';
import { fn } from '@ember/helper';
import { on } from '@ember/modifier';

import EditModeToggle from '../edit-quiz-questions/edit-mode-toggle.gts';
import type { TotalEditingMode } from './utils.ts';

const TotalEditorButtons: TemplateOnlyComponent<{
  Args: {
    total: QuizTotal;
    index: number;
    isEditing: boolean;
    isEditingMode: (index: number, mode: TotalEditingMode) => boolean;
    setEditingMode: (
      total: QuizTotal | null,
      index: number,
      mode: TotalEditingMode
    ) => void;
    onRemove: () => void;
  };
}> = <template>
  <div
    class="btn-group bg-primary-subtle shadow-sm question-editor-buttons-container
      {{if @isEditing 'is-editing'}}"
  >
    <EditModeToggle
      @isActive={{@isEditingMode @index "criteria"}}
      @icon="ph:funnel"
      @buttonText="Criteria"
      @onActivate={{fn @setEditingMode @total @index "criteria"}}
      @onDeactivate={{fn @setEditingMode null -1 "inactive"}}
    />

    <EditModeToggle
      @isActive={{@isEditingMode @index "feedback"}}
      @icon="ph:chat-centered-text"
      @buttonText="Feedback"
      @onActivate={{fn @setEditingMode @total @index "feedback"}}
      @onDeactivate={{fn @setEditingMode null -1 "inactive"}}
    />

    <button
      aria-label="Remove total"
      class="btn btn-outline-primary rounded-start-0 rounded-top-0 btn-sm px-2 py-1 flex-grow-0 ms-auto d-flex flex-row align-items-center
        {{if @isEditing 'rounded-bottom-0' 'rounded-bottom-1'}}"
      type="button"
      {{on "click" @onRemove}}
    ><iconify-icon inline icon="ph:trash" class="fs-4" /></button>
  </div>
</template>;

export default TotalEditorButtons;
